import * as React from 'react';
import classNames from 'classnames';
import { MenuItemProps as AntMenuItemProps } from 'antd/lib/menu/MenuItem';
import AntMenuItem from 'antd/lib/menu/MenuItem';

import styles from './Menu.module.scss';

export interface MenuItemProps extends AntMenuItemProps {}

export const MenuItem: React.FC<MenuItemProps> = (props: MenuItemProps) => {
	return <AntMenuItem className={classNames(props.className, styles.menuItem)} {...props} />;
};

export default MenuItem;
